export default __webpack_public_path__ + "static/media/mobile_feeding_status.0186e84a.png";